/**
 * @generated SignedSource<<20dfe27ce64a6e401864c2073fb18558>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditNotificationRuleRootQuery$variables = {
  uuid: any;
};
export type EditNotificationRuleRootQuery$data = {
  readonly notificationRule: {
    readonly name: string;
    readonly uuid: any;
    readonly " $fragmentSpreads": FragmentRefs<"UpsertNotificationRuleStepsContainer_notificationRule">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationsSettingsPage_query">;
};
export type EditNotificationRuleRootQuery = {
  response: EditNotificationRuleRootQuery$data;
  variables: EditNotificationRuleRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uuid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditNotificationRuleRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "NotificationRule",
        "kind": "LinkedField",
        "name": "notificationRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UpsertNotificationRuleStepsContainer_notificationRule"
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "NotificationsSettingsPage_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EditNotificationRuleRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "NotificationRule",
        "kind": "LinkedField",
        "name": "notificationRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filterJSON",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "groupBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "includeCostData",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updateSchedule",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "target",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraInstance",
                    "kind": "LinkedField",
                    "name": "instance",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraSpaceSelection",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": (v6/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "workType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraAssigneeSelection",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": (v6/*:: as any*/),
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "type": "NotificationRuleJiraTarget",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f3176ec846629cef4ac624d36ba1bc77",
    "id": null,
    "metadata": {},
    "name": "EditNotificationRuleRootQuery",
    "operationKind": "query",
    "text": "query EditNotificationRuleRootQuery(\n  $uuid: UUID!\n) {\n  notificationRule(uuid: $uuid) {\n    name\n    ...UpsertNotificationRuleStepsContainer_notificationRule\n    uuid\n    id\n  }\n  ...NotificationsSettingsPage_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment NotificationsSettingsPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n\nfragment UpsertNotificationRuleStepsContainer_notificationRule on NotificationRule {\n  uuid\n  name\n  description\n  filterJSON\n  groupBy\n  includeCostData\n  updateSchedule\n  target {\n    __typename\n    ... on NotificationRuleJiraTarget {\n      instance {\n        uuid\n        id\n      }\n      space {\n        type\n        value\n      }\n      workType\n      assignee {\n        type\n        value\n      }\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db7be7b3a3dd18d58220f5d451dbeac3";

export default node;
